import { put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import { getTierDeviationsStreamId } from '../helpers';
import { getCurrentMediaSource, getCurrentTierId } from '../selectors';

export default function* (): SagaIterator {
  const {
    mediaSource,
    tierId,
  }: {
    mediaSource: ReturnType<typeof getCurrentMediaSource>;
    tierId: ReturnType<typeof getCurrentTierId>;
  } = yield select(state => ({
    mediaSource: getCurrentMediaSource(state),
    tierId: getCurrentTierId(state),
  }));
  const streamId = getTierDeviationsStreamId(mediaSource, tierId);

  const isFetching: ReturnType<typeof selectors.isFetching> = yield select(
    selectors.isFetching,
    streamId
  );
  if (isFetching) {
    return;
  }

  yield put(withOffset.actions.fetch(streamId));
}
